// extracted by mini-css-extract-plugin
export default {"controlButton":"ui_controlButton__mhGB6"};